export default function isEmpty(value) {
    return !value || !value.trim();
}
